import React from 'react';
import ListItems from './ListItems';
import FOOTER_CONSTANT from '../FooterConstants/FooterConstant';
import { getImageComponent } from 'common/sharedTemplates/sharedTemplates';

const isJP = process.env.REACT_APP_TENANT_CODE === 'jp';

/**
 *  List Component
 * @param {*} props - Object
 */

const FooterListComp = props => {
  const { categoryHeaderText, subCategories = [], className = '', onClickHandler } = props;
  const { FOOTER_LINKS, SOCIAL_ICONS } = FOOTER_CONSTANT;

  const getItems = (list, class_name) => {
    return list.map((item, index) => {
      return (
        <ListItems
          key={index}
          onClickHandler={onClickHandler}
          dataTestId={`listItems-component-${item.name}`}
          className={class_name}
          {...item}
        >
          {item.name}
          {item?.externalurl && (
            <img
              src={item?.icon?.desktopImage}
              className={item?.icon?.desktopImage ? 'footerIcon' : 'hideFooterIcon'}
              alt='img'
            />
          )}
        </ListItems>
      );
    });
  };
  return (
    <React.Fragment>
      {className === FOOTER_LINKS && (
        <div className='ul-title'>
          <span role='heading' aria-level='2' className={`header-text-footer${isJP ? ' header-text-footer--jp' : ''}`}>
            {categoryHeaderText}
          </span>
          <ul className={className}>
            <>{getItems(subCategories, className)}</>
          </ul>
        </div>
      )}
      {className === SOCIAL_ICONS && (
        <ListItems data-testid='listItems-component' onClickHandler={onClickHandler} className={className} {...props}>
          {getImageComponent(props.url, 'FOOTER_SOCIAL_ICONS', '', `${props.name}`)}
        </ListItems>
      )}
    </React.Fragment>
  );
};

export { FooterListComp };
